const findHiddenData = () =>
  document.querySelectorAll('#historical-data .data.dpn')

const handleButtonRender = (button) => {
  const HiddenDataAfterLoading = findHiddenData()
  if (HiddenDataAfterLoading.length === 0) {
    button.parentNode.removeChild(button)
  }
}

const showHiddenData = (event) => {
  const button = document.querySelector('#historical-data .load-more')
  if (event.target !== button) {
    return
  }

  const firstTwentyHiddenData = Array.from(findHiddenData()).slice(0, 20)
  firstTwentyHiddenData.forEach((element) => element.classList.remove('dpn'))

  handleButtonRender(button)
}

window.addEventListener('load', () => {
  const historicalDataSection = document.querySelector('#historical-data')

  if (!historicalDataSection) {
    return
  }

  historicalDataSection.addEventListener('click', showHiddenData)
})
